export const URL_SERVER = window._env_
	? window._env_.URL_SERVER
	: 'http://localhost:8444';
export const URL_DATA_EXCHANGER = window._env_
	? window._env_.URL_DATA_EXCHANGER
	: 'http://localhost:8444/';
export const URL_SPEECH = window._env_
	? window._env_.URL_SPEECH
	: 'https://speech.etcd.kloud.one';
export const CLIENT_ID = window._env_
	? window._env_.CLIENT_ID
	: '66b1cdbb6aab91a741228ad434b18f24';
export const TYPE_SERVICE = window._env_
	? window._env_.STATE_SERVICE
	: 'getter';
export const LS_MESSAGE =
	'Пожалуйста, введите клавишами телефона номер лицевого счета, по окончанию ввода нажмите клавишу решетка, или произнесите последовательно каждую цифру';
export const DEF_LS_MESSAGE_VOICE =
	'Назовите номер лицевого счёта, проговаривая последовательно каждую цифру.';
export const DEF_LS_MESSAGE_DTMF =
	'Введите клавишами телефона номер лицевого счёта, по окончанию ввода нажмите клавишу решётка.';
export const DEF_LS_MESSAGE_DTMF_VOICE =
	'Введите клавишами телефона номер лицевого счёта, по окончанию ввода нажмите клавишу решётка или произнесите последовательно каждую цифру.';
export const DEF_METER_MESSAGE_VOICE =
	'Произнесите округленные показания счётчика, проговаривая последовательно каждую цифру';
export const DEF_METER_MESSAGE_VOICE_DOUBLE =
	' Произнесите дробные показания счётчика, проговаривая последовательно каждую цифру, в качестве разделителя скажите слово точка';
export const DEF_METER_MESSAGE_DTMF =
	'Введите клавишами телефона округленные показания, по окончанию ввода нажмите клавишу решётка.';
export const DEF_METER_MESSAGE_DTMF_DOUBLE =
	'Введите клавишами телефона дробные показания, в качестве разделителя используйте клавишу звездочка, по окончанию ввода нажмите клавишу решётка.';
export const DEF_METER_MESSAGE_DTMF_VOICE =
	'Введите клавишами телефона округленные показания, по окончанию ввода нажмите клавишу решётка или произнесите последовательно каждую цифру';
export const DEF_METER_MESSAGE_DTMF_VOICE_DOUBLE =
	'Введите клавишами телефона дробные показания, в качестве разделителя используйте клавишу звездочка, по окончанию ввода нажмите клавишу решётка или произнесите последовательно каждую цифру, в качестве разделителя скажите слово точка';
export const DEF_HELLO_TEXT = 'Здравствуйте';
export const DEF_GOOD_BUY_TEXT = 'Спасибо за звонок';
export const DEF_INFO_MESSAGE = 'Обратитесь в вашу управляющую компанию';
export const DEF_INPUT_TYPE = 'DTMFinput';
export const DEF_CACHING = false;
export const DEF_VOICE_METER_NUMBER = false;
export const DEF_LOWER_READINGS = true;
export const DEF_USE_DOUBLE_VALUES = false;
export const DEF_USE_SERVICE_FILTER = false;
export const SCHEDULE_TYPE = 'always';
export const GETTER_START = '0';
export const GETTER_END = '0';
export const SCHEDULE_TEXT = 'Приём показания счётчиков сейчас не производится';
export const RECORDING = true;
export const GMT = '3';
export const DEF_VOICE = 'oksana';
export const URL_AUTH = window._env_
	? window._env_.URL_AUTH
	: 'https://id.trusted.plus/idp/sso/oauth?client_id=66b1cdbb6aab91a741228ad434b18f24&redirect_uri=http://localhost:8444/api/v1/auth/oauth2/callback&scope=userprofile&state=getter';
export const BITRIX_INTEGRATION = true;
// eslint-disable-next-line
export const transformTime = (time) => {
	return `${time.getFullYear()}-${
		time.getMonth() + 1 < 10 ? `0${time.getMonth() + 1}` : time.getMonth() + 1
	}-${time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()} ${
		time.getHours() < 10 ? `0${time.getHours()}` : time.getHours()
	}:${time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes()}`;
};
// eslint-disable-next-line
export const normalizeTime = (time) => {
	const startTimeNorm = transformTime(time[0]).split(' ');
	const endTimeNorm = transformTime(time[1]).split(' ');
	if (startTimeNorm[1] === '00:00' && endTimeNorm[1] === '00:00') {
		endTimeNorm[1] = '23:59';
	}
	return endTimeNorm.join(' ');
};
export const MARKET_LINK_BUY = window._env_
	? window._env_.MARKET_LINK_BUY
	: 'https://kloud.one/counter/#buy';
export const URL_SERVICES = window._env_
	? window._env_.URL_SERVICES
	: 'https://lkdev.etcd.kloud.one';
export const URL_SERVICE_ID = window._env_
	? window._env_.URL_SERVICE_ID
	: 'https://id.etcd.kloud.one';
export const URL_SERVICE_CRM_TOOLS = window._env_
	? window._env_.URL_SERVICE_CRM_TOOLS
	: 'https://crmtools-dev.kloud.one';